<template>
  <div>
    <loading-screen v-if="isLoading" />
    <div class="p-6 text-gray-900 bg-white rounded-lg text-left font-medium shadow-lg">
      <h1 class="font-semibold text-xl">
        <fa-icon
          :icon="['fas', 'shield-alt']"
          size="lg"
          class="mr-1 text-blue-400"
        />
        {{ $t("Admin", "Admin") }}
      </h1>
      <div class="mx-48 mt-4 p-4 text-center">
        <h1 class="text-xl font-normal">
          {{ $t("Create new subscription", "Create new subscription") }}
        </h1>
        <subscription type="new" />
        <h1 class="text-xl font-normal mt-6">
          {{ $t("Manage subscriptions", "Manage subscriptions") }}
        </h1>
        <select
          v-model="selectedSubscriptionId"
          class="block w-full rounded-lg my-4 mx-1 py-2 pl-2 bg-gray-200 text-sm"
        >
          <option
            v-for="subscription in subscriptions"
            :key="subscription.id"
            :value="subscription.id"
          >
            {{ subscription.name }}
          </option>
        </select>
        <div class="flex justify-between w-full">
          <z-button
            type="primary"
            :text="$t('Change to selected subscription', 'Change to selected subscription')"
            @click="changeSubscription"
          />
          <z-button
            type="primary"
            :text="$t('Edit selected subscription', 'Edit selected subscription')"
            @click="showUpdatePopup"
          />
          <z-button
            type="destructive"
            :text="$t('Deleted selected subscription', 'Deleted selected subscription')"
            @click="deleteSubscription"
          />
        </div>
      </div>
    </div>
    <popup
      v-if="isEditPopupShown"
      :is-closable="true"
      :title="editPopupTitle"
      @close="isEditPopupShown = false"
    >
      <subscription
        type="edit"
        :subscription="selectedSubscription"
        @updated="isEditPopupShown = false"
      />
    </popup>
    <div
      v-if="isEditPopupShown"
      class="fixed z-20 top-0 left-0 bottom-0 right-0 bg-white opacity-75"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { actionNames } from '@/admin/store'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faShieldAlt } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Subscription from '../global/components/Subscription'
import ZButton from '../global/ui/Button'
import Popup from '../global/ui/Popup'
import LoadingScreen from '@/global/ui/LoadingScreen'

library.add(faShieldAlt)
export default {
  name: 'Admin',
  components: {
    'fa-icon': FontAwesomeIcon,
    Subscription,
    ZButton,
    Popup,
    LoadingScreen
  },
  data () {
    return {
      selectedSubscriptionId: null,
      isEditPopupShown: false,
      isLoading: false
    }
  },
  computed: {
    ...mapState({
      subscriptions: state => [...state.admin.subscriptions].sort((a, b) => a.name < b.name ? -1 : 1)
    }),
    selectedSubscription () {
      return this.subscriptions.find(s => s.id === this.selectedSubscriptionId)
    },
    editPopupTitle () {
      return this.$t('Edit popup title', {
        subscriptionName: this.selectedSubscription ? this.selectedSubscription.name : '',
        defaultValue: 'Edit {{ subscriptionName }} subscription'
      })
    }
  },
  async mounted () {
    this.isLoading = true
    await this.$store.dispatch(actionNames.INIT_SUBSCRIPTIONS)
    const currentSubscription = this.subscriptions.find(g => g.id === this.$store.state.auth.clientId)
    if (currentSubscription) {
      this.selectedSubscriptionId = currentSubscription.id
    }
    this.isLoading = false
  },
  methods: {
    deleteSubscription () {
      this.$store.dispatch(actionNames.DELETE_SUBSCRIPTION, this.selectedSubscription.id)
    },
    showUpdatePopup () {
      this.isEditPopupShown = true
    },
    changeSubscription () {
      this.$store.dispatch(actionNames.CHANGE_SUBSCRIPTION, this.selectedSubscription.id)
    }
  }
}
</script>
